var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"type":"password","placeholder":"请输入内容","show-password":""},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }